import axios from 'axios';
import {
  SUPERVISOR_USERS_REQUEST,
  SUPERVISOR_USERS_SUCCESS,
  SUPERVISOR_USERS_FAIL,
  SUPERVISOR_MASTER_LIST_REQUEST,
  SUPERVISOR_MASTER_LIST_SUCCESS,
  SUPERVISOR_MASTER_LIST_FAIL,
  SUPERVISOR_MASTER_CREATE_REQUEST,
  SUPERVISOR_MASTER_CREATE_SUCCESS,
  SUPERVISOR_MASTER_CREATE_FAIL,
  SUPERVISOR_MASTER_UPDATE_REQUEST,
  SUPERVISOR_MASTER_UPDATE_SUCCESS,
  SUPERVISOR_MASTER_UPDATE_FAIL,
  SUPERVISOR_MASTER_DELETE_REQUEST,
  SUPERVISOR_MASTER_DELETE_SUCCESS,
  SUPERVISOR_MASTER_DELETE_FAIL,
  SUPERVISOR_MASTER_UPLOAD_REQUEST,
  SUPERVISOR_MASTER_UPLOAD_SUCCESS,
  SUPERVISOR_MASTER_UPLOAD_FAIL,
} from '../constants/supervisorMasterConstants';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

const authConfig = (userInfo) => ({
  headers: { Authorization: `Bearer ${userInfo.token}` },
});

const authJsonConfig = (userInfo) => ({
  headers: {
    'Content-Type': 'application/json',
    Authorization: `Bearer ${userInfo.token}`,
  },
});

export const listCollectionSupervisors = () => async (dispatch, getState) => {
  try {
    dispatch({ type: SUPERVISOR_USERS_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/supervisor-master/supervisors`,
      authConfig(userInfo),
    );
    dispatch({ type: SUPERVISOR_USERS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: SUPERVISOR_USERS_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const listSupervisorMasters = (search = '', page = 1, limit = 50, month = '', year = '') => async (dispatch, getState) => {
  try {
    dispatch({ type: SUPERVISOR_MASTER_LIST_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.get(
      `${API_URL}/supervisor-master?search=${search}&page=${page}&limit=${limit}&month=${month}&year=${year}`,
      authConfig(userInfo),
    );
    dispatch({ type: SUPERVISOR_MASTER_LIST_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: SUPERVISOR_MASTER_LIST_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const createSupervisorMaster = (recordData) => async (dispatch, getState) => {
  try {
    dispatch({ type: SUPERVISOR_MASTER_CREATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.post(
      `${API_URL}/supervisor-master`,
      recordData,
      authJsonConfig(userInfo),
    );
    dispatch({ type: SUPERVISOR_MASTER_CREATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: SUPERVISOR_MASTER_CREATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const updateSupervisorMaster = (id, recordData) => async (dispatch, getState) => {
  try {
    dispatch({ type: SUPERVISOR_MASTER_UPDATE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.put(
      `${API_URL}/supervisor-master/${id}`,
      recordData,
      authJsonConfig(userInfo),
    );
    dispatch({ type: SUPERVISOR_MASTER_UPDATE_SUCCESS, payload: data });
  } catch (error) {
    dispatch({
      type: SUPERVISOR_MASTER_UPDATE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const deleteSupervisorMaster = (id) => async (dispatch, getState) => {
  try {
    dispatch({ type: SUPERVISOR_MASTER_DELETE_REQUEST });
    const { userLogin: { userInfo } } = getState();
    await axios.delete(`${API_URL}/supervisor-master/${id}`, authConfig(userInfo));
    dispatch({ type: SUPERVISOR_MASTER_DELETE_SUCCESS });
  } catch (error) {
    dispatch({
      type: SUPERVISOR_MASTER_DELETE_FAIL,
      payload: error.response?.data?.message || error.message,
    });
  }
};

export const uploadSupervisorMasterExcel = (formData) => async (dispatch, getState) => {
  try {
    dispatch({ type: SUPERVISOR_MASTER_UPLOAD_REQUEST });

    if (!navigator.onLine) {
      throw new Error('No internet connection. Please check your network and try again.');
    }

    const { userLogin: { userInfo } } = getState();
    const { data } = await axios.post(
      `${API_URL}/supervisor-master/upload`,
      formData,
      { headers: { Authorization: `Bearer ${userInfo.token}` } },
    );
    dispatch({ type: SUPERVISOR_MASTER_UPLOAD_SUCCESS, payload: data });
  } catch (error) {
    const message = !error.response && (error.message === 'Network Error' || !navigator.onLine)
      ? 'No internet connection. Please check your network and try again.'
      : error.response?.data?.message || error.message;
    dispatch({
      type: SUPERVISOR_MASTER_UPLOAD_FAIL,
      payload: message,
    });
  }
};
